// Shared status tag: semantic surface and border tokens with secondary text, so it adapts to light/dark mode (unlike antd preset Tag colors).
import type { CSSProperties, ReactNode } from 'react';
import { Tag, theme } from 'antd';

export type StatusTagTone = 'success' | 'error' | 'warning' | 'info' | 'neutral';

interface StatusTagProps {
  tone?: StatusTagTone;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const toneSurfaceTokens = {
  success: { background: 'colorSuccessBg', border: 'colorSuccessBorder' },
  error: { background: 'colorErrorBg', border: 'colorErrorBorder' },
  warning: { background: 'colorWarningBg', border: 'colorWarningBorder' },
  info: { background: 'colorInfoBg', border: 'colorInfoBorder' },
  neutral: { background: 'colorFillTertiary', border: 'colorBorderSecondary' },
} as const satisfies Record<StatusTagTone, { background: string; border: string }>;

export function StatusTag({ tone = 'neutral', children, className, style }: StatusTagProps) {
  const { token } = theme.useToken();
  const surfaceTokens = toneSurfaceTokens[tone];
  return (
    <Tag
      className={className}
      style={{
        backgroundColor: token[surfaceTokens.background],
        color: token.colorTextSecondary,
        borderColor: token[surfaceTokens.border],
        marginInlineEnd: 0,
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}
